import { List, useDataGrid } from "@refinedev/mui";
import React from "react";

import { GridRowSelectionModel } from "@mui/x-data-grid";

import { IBlockUser } from "./interfaces";
import { SearchToolbar, DataGridPanel, ListPageHeader } from "components/list";
import { blockUserColumns } from "./components/blockUserColumns";
import { blockUserSearchFields } from "./components/blockUserSearchFields";

export const BlockUserList: React.FC = () => {
    const { dataGridProps, setFilters, filters, tableQueryResult } =
        useDataGrid<IBlockUser>({
            initialCurrent: 1,
            initialPageSize: 20,
        });

    const [rowSelectionModel, setRowSelectionModel] =
        React.useState<GridRowSelectionModel>([]);

    // refine의 rowCount는 fetch 중 잠깐 0으로 떨어져 "전체 0건"이 깜빡인다.
    const lastRowCountRef = React.useRef<number | undefined>(undefined);
    if (!dataGridProps.loading && typeof dataGridProps.rowCount === "number") {
        lastRowCountRef.current = dataGridProps.rowCount;
    }

    return (
        <List breadcrumb={<></>}>
            <ListPageHeader
                count={lastRowCountRef.current}
                description="사용자 간 차단 관계 목록"
            />

            <SearchToolbar
                fields={blockUserSearchFields}
                filters={filters}
                setFilters={setFilters}
            />

            <DataGridPanel
                {...dataGridProps}
                columns={blockUserColumns}
                isError={tableQueryResult.isError}
                errorMessage="차단 목록을 불러오지 못했습니다."
                emptyMessage="조건에 맞는 차단 내역이 없습니다."
                pageSizeOptions={[10, 20, 30, 50, 100]}
                disableColumnFilter
                filterModel={undefined}
                checkboxSelection
                onRowSelectionModelChange={(model) => setRowSelectionModel(model)}
                rowSelectionModel={rowSelectionModel}
            />
        </List>
    );
};
